module.exports = new __parcel__URL__("GAME_Timeline-graphic.6f402fc9.png").toString();